<template>
  <!-- 交易详情 -->
  <div id="Order">
    <!-- 内容区域 -->
    <head>
      <link rel="stylesheet" href="https://cdn.bootcss.com/material-design-icons/3.0.1/iconfont/material-icons.css">
    </head>
    <!-- <div style="width: 100%; background: #fff;"> -->

    <mu-flex direction="column" style="width: 100%;height: 100%;">

      <mu-flex class="is-full-width">
        <!-- <mu-appbar style="width: 100%;" color="primary">
  <mu-button icon slot="left">
    <mu-icon value="menu"></mu-icon>
  </mu-button>
  Title

  <mu-button flat slot="right">LOGIN</mu-button> -->
        </mu-appbar>
        <mu-appbar class="is-full-width" title="Order record" color="#fff" textColor="#303644" z-depth=0>
          <mu-button @click="leftBtn" icon slot="left">
            <mu-icon value="arrow_back"></mu-icon>
          </mu-button>
        <!--  <mu-button @click="rightBtn" icon slot="right">
            <mu-icon value="menu"></mu-icon>
          </mu-button> -->
        </mu-appbar>

      </mu-flex>

      <mu-flex class="is-full-width content" fill style="overflow-y: auto;">
        <!-- <mu-flex direction="column" style="height: 100%; width: 100%;">
          <TDetailsHead ref="TDetailsHead" style="width: 100%;"></TDetailsHead>
          <TDetailsLegenda style="width: 100%;"></TDetailsLegenda>
          <TDetailsList ref="TDetailsList" style="width: 100%;" fill></TDetailsList>
        </mu-flex> -->
        <template>
          <mu-load-more @refresh="refresh" :refreshing="refreshing" :loading="loadings" :loaded-all="loadedall"
            @load="loadsss" style="width: 100%">
            <el-table :data="tableData" :show-header="false" style="width: 100%" empty-text="wait">
              <el-table-column>
                <template slot-scope="scope">
                  <mu-flex class="is-full-width" fill>
                    <!-- <div class="product f-row"> -->
                    <!-- <img :src="getImage(scope.row)"> -->
                    <!-- <img src="../assets/image/btn_3_0.png" style="height: 100%;width: 50px;transform: translateY(25%);"/> -->
                    <!-- <img :src="imageList[scope.row.image]" style="height: 100%;width: 50px;align-self: center;" /> -->
                    <div class="detail" style="width: 100%;margin-left: 10px;">

                      <div style="display: flex;justify-content: space-between;height: 3.125rem;">
                        <p v-if="scope.row.instId == 'dot-usd-swap'" style="text-align: center;float: left;">
                          DOT
                        </p>

                        <p v-if="scope.row.instId == 'fil-usd-swap'" style="text-align: center;float: left;">
                          FIL
                          <font color="#DCDCDC" size="1">/USDT</font>
                        </p>

                        <p v-if="scope.row.instId == 'ltc-usd-swap'" style="text-align: center;float: left;">
                          LTC
                          <font color="#DCDCDC" size="1">/USDT</font>
                        </p>

                        <p v-if="scope.row.instId == 'xrp-usd-swap'" style="text-align: center;float: left;">
                          XRP
                          <font color="#DCDCDC" size="1">/USDT</font>
                        </p>

                        <p v-if="scope.row.instId == 'ada-usd-swap'" style="text-align: center;float: left;">
                          ADA
                          <font color="#DCDCDC" size="1">/USDT</font>
                        </p>

                        <p v-if="scope.row.instId == 'etc-usd-swap'" style="text-align: center;float: left;">
                          ETC
                          <font color="#DCDCDC" size="1">/USDT</font>
                        </p>

                        <p v-if="scope.row.instId == 'btc-usd-swap'" style="text-align: center;float: left;">
                          BTC
                        </p>

                        <p v-if="scope.row.instId == 'eth-usd-swap'" style="text-align: center;float: left;">
                          ETH
                          <font color="#DCDCDC" size="1">/USDT</font>
                        </p>

                        <p v-if="scope.row.instId == 'doge-usd-swap'" style="text-align: center;float: left;">
                          DOGE
                          <font color="#DCDCDC" size="1">/USDT</font>
                        </p>

                        <p v-if="scope.row.instId == 'bch-usd-swap'" style="text-align: center;float: left;">
                          BCH
                          <font color="#DCDCDC" size="1">/USDT</font>
                        </p>
                        <p style="text-align: center;float: left;">

                          <font v-if="scope.row.dDY <= 0" color="#DCDCDC" style="background-color: #aa2116;border-radius: 5px;">&#160;Buy fall&#160;</font>
                          <font v-if="scope.row.dDY >= 1" color="#DCDCDC" style="background-color: #225a1f;border-radius: 5px;">&#160;Buy up&#160;</font>
                          <p style="color: #303644;font-size: 0.7rem;">
                            <font> {{Math.abs((scope.row.price-scope.row.end_price).toFixed(4))}} </font>
                            <br><font> {{Math.abs(scope.row.sH)}} %</font>
                          </p>
                          <!-- <p v-if="scope.row.sH <= 0" style="color: #aa2116;font-size: 0.5rem;">
                            <font> {{(scope.row.price-scope.row.end_price).toFixed(4)}} </font>
                            <br><font> {{scope.row.sH}} %</font>
                          </p>
                          <p v-if="scope.row.sH > 0" style="color: #225a1f;font-size: 0.5rem;">
                            <font> {{(scope.row.price-scope.row.end_price).toFixed(4)}} </font>
                            <br><font> {{scope.row.sH}} %</font>
                          </p> -->
                        </p>
                        <p style="width: 50%;text-align: center;font-weight: bold;">
                          <font color="#303644">{{scope.row.times}}X</font>
                        </p>
                      </div>

                      <mu-flex class="flex-wrapper">
                          <mu-flex class="flex-demo" justify-content="left" fill>
                     <!-- <p style="width: 100%;height: 1.4375rem;margin: 0rem;margin-top: -0.625rem;left;font-size: 0.9375rem">
                        {{scope.row.end_price}}
                      </p> -->
                            <font>
                            <font color="#303644" size="3.9375rem;">{{scope.row.end_price}}</font><br>
                            <font color="#303644" size="0.3rem;">Entry price</font><br>
                            <font color="#303644" size="0.3rem;">{{scope.row.price}}</font>
                            </font>
                            </mu-flex>
                          <mu-flex class="flex-demo" justify-content="left" fill>
                            <font>
                            <font color="#303644" size="0.3rem;">Investment</font><br>
                            <font color="#303644" size="0.3rem;">{{scope.row.count}}BTC</font>
                            </font>
                            </mu-flex>
                          <mu-flex class="flex-demo" justify-content="center" fill>
                            <font>
                            <font color="#303644" size="0.3rem;">Profit and loss</font><br>
                            <font>
                              <p v-if="scope.row.isEND==0" style="color: #303644;font-size: 0.7rem;">
                            <font v-if="scope.row.end_count > 0">+</font>
                              {{(scope.row.end_count).toFixed(5)}}BTC
                            <br> <font size="0.3rem;">≈{{(scope.row.end_price*scope.row.count*scope.row.times).toFixed(5)}}$</font>
                              </p>
                              <p v-if="scope.row.isEND==1&&scope.row.end_count <= 0" style="color: #aa2116;font-size: 0.7rem;">
                            <font v-if="scope.row.end_count > 0">+</font>
                              {{(scope.row.end_count).toFixed(5)}}BTC
                            <br> <font size="0.3rem;">≈{{(scope.row.end_price*scope.row.count*scope.row.times).toFixed(5)}}$</font>
                              </p>
                              <p v-if="scope.row.isEND==1&&scope.row.end_count > 0" style="color: #225a1f;font-size: 0.7rem;">
                            <font v-if="scope.row.end_count > 0">+</font>
                              {{(scope.row.end_count).toFixed(5)}}BTC
                            <br> <font size="0.3rem;">≈{{(scope.row.end_price*scope.row.count*scope.row.times).toFixed(5)}}$</font>
                              </p>

                            <!-- <font v-if="scope.row.sH > 0">+</font><font v-if="scope.row.sH <= 0">-</font>
                            <font color="#303644" size="0.3rem;">{{(scope.row.count*scope.row.times).toFixed(5)}}BTC</font> -->
                            <!-- <br> <font color="#303644" size="0.3rem;">≈{{(scope.row.end_price*scope.row.count*scope.row.times).toFixed(5)}}$</font> -->
                            </font>
                            </font>
                            </mu-flex>
                        </mu-flex>
                    </div>
                    <!-- </div> -->
                  </mu-flex>
                </template>
              </el-table-column>
            </el-table>
          </mu-load-more>
        </template>
      </mu-flex>

      <!-- <mu-flex class="is-full-width BottomFlex">
        <mu-button @click="submit01" class="flex-demo Bottom_01" color="secondary" fill>
          <img src="../../../assets/image/buy.png" style="height: 40px;width: 40px;" />
            {{CurrentData.bidPx}}  Buy fall
        </mu-button>
        <mu-button @click="submit02" class="flex-demo Bottom_02" color="secondary" fill>
          <img src="../../../assets/image/up.png" style="height: 40px;width: 40px;" />
            {{CurrentData.bidPx}}  Buy up
        </mu-button>
      </mu-flex> -->

    </mu-flex>

  </div>
</template>

<script>
  import {
    lStorage,
    sStorage
  } from "@Comm/js/Storage.js"
  export default {
    data() {
      return {
        //表格
        tableData: [],
        //下拉刷新，上拉加载
        refreshing: false,
        loadings: false,
        loadedall: false,
        titleStr: ''
      }
    },
    mounted() {
  //     var UserInfo = JSON.parse(sStorage.getItem("UserInfo"));
  //     this.UserType = UserInfo.type;

  //     window.T_Details = this;
      this.titleStr = this.$route.query.instId;

      this.loadOrder();
    },
    methods: {
      leftBtn() {
        this.$router.go(-1); //返回上一层
      },
      loadOrder() {
        const that = this;

        let params = new URLSearchParams();
        params.append('instId', this.titleStr);
		params.append('token',sStorage.getItem("token"));
        this.$http.get('/order/GetOrder', {
            params
          })
          .then(function(response) {
            console.log(response.data);
            that.refreshing = false;
            if (response.data.success || response.data.code == 1) {
              that.tableData = response.data.content;
            } else {
              that.$message.error(response.data.message);
            }
          });
      }
    },
    components: {
    }
  };
</script>

<style>

  @import '../../../Comm/css/CommCSS.css';
 /* #Order .mu-appbar .mu-appbar-title {
    text-align: center;
  } */
  #Order .is-full-width {
    width: 100%;
  }

  #Order .content {
    flex: 1
  }
</style>



// WEBPACK FOOTER //
// src/OK_Scott/components/Order/Order.vue